const themes = require('./themes');
const tokens = require('./tokens');

module.exports = {
  themes,
  tokens,
};
